<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
          <h1>Trade Plate Report Builder</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
              <strong>Report Options</strong>
          </div>
          <div class="form-container">
            <b-row>
                <b-col sm="4">
                    <b-form-group>
                        <label for="company">Company</label>
                        <b-form-select id="company" v-if="companiesLoaded"  v-model="reportParams.companyId"
                            :plain="true"
                            :options="companies"
                            :disabled="!isMinimumSuperAdmin">
                        </b-form-select>
                        <div v-if="!companiesLoaded" >
                            <i class="fa fa-spin fa-spinner"></i>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <label for="area">Area</label>
                        <b-form-select id="area" v-if="areasLoaded"  v-model="reportParams.areaId"
                            :plain="true"
                            :options="areas"
                            :disabled="!isMinimumCompanyUser">
                        </b-form-select>
                        <div v-if="!areasLoaded" >
                          <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                        </div>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <label for="site">Site</label>
                        <b-form-select id="site" v-if="sitesLoaded"  v-model="reportParams.siteId"
                            :plain="true"
                            :options="sites"
                            :disabled="!isMinimumAreaUser">
                        </b-form-select>
                        <div v-if="!sitesLoaded" >
                          <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label for="registration">Registration</label>
                        <b-form-input type="text" id="registration" class="uppercase" v-model="reportParams.regNumber"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label for="workInProgress">WIP Number</label>
                        <b-form-input type="text" id="workInProgress" v-model="reportParams.wipNumber"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label for="dateFrom">Date From</label>
                        <b-form-input type="date" id="dateFrom" v-model="reportParams.dateFrom"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label for="dateTo">Date To</label>
                        <b-form-input type="date" id="dateTo" v-model="reportParams.dateTo"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="12" sm="12" md="12">
                <p>
                  <b-button v-on:click="runReport" variant="primary">
                    <i class="fa fa-search"></i>&nbsp; Fetch Results
                  </b-button>
                </p>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card v-if="reportFetchStarted">
          <div slot="header">
              <strong>Report Results</strong>
          </div>
          <div v-if="!resultsLoaded" class="form-container">
              <LoadingSpinner />
          </div>
          <div v-if="resultsLoaded" class="form-container">
            <b-row>
              <b-col sm="3">
                <b-form-group
                  label="Filter"
                  label-for="tableFilter"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="tableFilter" type="text" id="tableFilter"></b-form-input>
                </b-form-group>                                    
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <b-button v-on:click="csvExport" variant="primary">
                    <i class="fa fa-download"></i>&nbsp; Export CSV
                  </b-button>
                </b-form-group>                                    
              </b-col>                         
            </b-row>
            <b-row>
              <b-col cols="12">
                <div id="customer-list">
                  <!--<c-table :filter="tableFilter" :table-data="contactItems" :fields="tableFields" :perPage="10" hover bordered caption="All Contacts"></c-table>-->
                  <b-table
                    id="results-table"
                    class="datalist-table"
                    selectable
                    hover 
                    bordered
                    select-mode="single"                                            
                    :items="reportItems" 
                    :fields="tableFields"
                    :filter="tableFilter"
                    responsive="sm"
                      >
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import cTable from '../../components/table/Table';
import moment from 'moment';

const getHTTPHeaders = () => {
  let userObj = JSON.parse(localStorage.getItem('user'));
  let headerConfig = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Bearer ' + userObj.token,
    }
  }
  return headerConfig;
}

const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user != null) {
            resolve(user);
        }
        else {
            reject();
        }
        
    });
}

const getCompaniesList = (($http) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
      $http.get('getCompaniesForSelect', headersObj)
        .then((response) => {
          // let companies = response.data.companies.map((element) => {
          //   let newElement = {
          //     value: element.id,
          //     text: element.company_name
          //   };
          //   return newElement;
          // });
          resolve(response.data.companies);
        })
        .catch ((err) => {
          console.error(err);
          reject(err);
        });
  });
});

const getSiteList = (($http, areaId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('getSitesForSelect?area_id=' + areaId, headersObj)
            .then((response) => {
                resolve(response.data.sites);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAreaList = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getAreasForSelect?company_id=' + companyId, headersObj)
            .then((response) => {
                resolve(response.data.areas);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getTemplateList = (($http, companyId, siteId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getTemplatesForSelect?company_id=' + companyId + '&site_id=' + siteId, headersObj)
            .then((response) => {
                resolve(response.data.templates);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getUsers = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('users', headersObj)
            .then((response) => {
                resolve(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const fetchReportData = (($http, reportParams) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        let reportParamsString = `dateFrom=${reportParams.dateFrom}&dateTo=${reportParams.dateTo}&company_id=${reportParams.companyId}&registration_number=${reportParams.regNumber}&supplier_wip_number=${reportParams.wipNumber}`;
        if (reportParams.areaId > 0) {
          reportParamsString += `&area_id=${reportParams.areaId}`;
        }
        if (reportParams.siteId > 0) {
          reportParamsString += `&site_id=${reportParams.siteId}`;
        }
        $http.get('reports/stats/plates?' + reportParamsString, headersObj)
            .then((response) => {
                resolve(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

export default {

  name: 'tradePlateReport',
  components: {
    LoadingSpinner: LoadingSpinner,
    cTable
  },
  data: function () {
    let datenow=new Date(Date.now());
    return {
      reportParams: {
        companyId: 0,
        areaId: 0,
        siteId: 0,
        regNumber: '',
        wipNumber: '',
        dateFrom: datenow.getFullYear() + '-' + parseInt(datenow.getMonth()+1) + '-' + datenow.getDate(),

        dateTo: datenow.getFullYear() + '-' + parseInt(datenow.getMonth()+1) + '-' + datenow.getDate()
      },
      tableFilter: '',
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
          {key: 'site.site_name', label: 'Site', sortable: true},
          {key: 'supplier_wip_number', label: 'WIP Number', sortable: true},
          {key: 'registration_number', label: 'Reg Number', sortable: true},
          {key: 'template.template_name', label: 'Template', sortable: true},
          {key: 'printed_by_name', label: 'Printed By', sortable: true},
          {key: 'formatted_date', label: 'Print Date', sortable: true},
          {key: 'printer_used', label: 'Printer', sortable: true}
        ],
      instantRegValue: '',
      reportItems: [],
      exportReportData: [],
      companies: [],
      areas: [],
      sites: [],
      resultsLoaded: false,
      reportFetchStarted: false,
      companiesLoaded: false,
      sitesLoaded: false,
      areasLoaded: false,
      allowRunReport: false,
      userAuthLevel : ''
    }
  },
  created () {
    this.getInitialData();
    this.setUIForCurrentUser();
  },
  watch: {
    'reportParams.companyId': function(val, oldVal) {
      
      // get the branches for the selected company
      // clear it out first
      this.$data.areas = [];
      getAreaList(this.$http, val)
        .then((areaList) => {
          if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
            this.$data.areas.push({value:0, text: 'All Areas'});
            this.$data.reportParams.areaId = 0;
            this.$data.reportParams.siteId = 0;
          }
          areaList.map((item) => {
            this.$data.areas.push(item);
          });
          this.$data.areasLoaded = true;
        })
        .catch ((err) => {
          console.error(err);
        }); 
    },
    'reportParams.areaId': function(val, oldVal) {
      // get the sites for the selected branch
      // clear it out first
      this.$data.sites = [];
      getSiteList(this.$http, val)
        .then((sitesList) => {
          if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
            this.$data.sites.push({value:0, text: 'All Sites'});
            this.$data.reportParams.siteId = 0;
          }
          sitesList.map((item) => {
            this.$data.sites.push(item);
          });
          this.$data.sitesLoaded = true;
        })
        .catch ((err) => {
          console.error(err);
        }); 
    }
  },
  computed: {
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      console.log('Company: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      console.log('Company: ', returnVal);
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      console.log('Area: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      console.log('Area: ', returnVal);
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      console.log('Site: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    }
  },
  methods: {
    setUIForCurrentUser() {
      getCurrentUser()
      .then((userDetails) => {
        this.$data.reportParams.companyId = userDetails.company_id;
        this.$data.reportParams.areaId = userDetails.branch_id;
        this.$data.reportParams.siteId = userDetails.site_id;
        this.$data.userAuthLevel = userDetails.auth;
      })
    },
    getInitialData() {
      getCompaniesList(this.$http)
        .then((results) => {
          this.$data.companies = results;
          this.$data.companiesLoaded = true;
        });
    },
    async runReport() {
      this.$data.reportFetchStarted = true;
      // get the report data to work on
      const reportData  = await fetchReportData(this.$http, this.$data.reportParams);
      this.$data.reportItems = reportData.plates.map((item) => {
        item.formatted_date = moment(item.printed_date).format("lll");
        return item;
      });
      // set the export data
      this.$data.exportReportData = reportData.plates.map((plateItem) => {
        return {
          "Plate Id": plateItem.plate_id,
          "Company Name": plateItem.company.company_name,
          "Area Name": plateItem.area.area_name,
          "Site Name": plateItem.site.site_name,
          "Registration Number": plateItem.registration_number,
          "WIP Number": plateItem.supplier_wip_number,
          "Printed By": plateItem.printed_by_name,
          "Printed Date": '"' + moment(plateItem.printed_date).format("LL") + '"',
          "Printed Time": moment(plateItem.printed_date).format("LTS"),
          "Printer Used": plateItem.printer_used,
          "Template Used": (plateItem.template ? plateItem.template.template_name : ''),
          "Plate Size": plateItem.plate_width + ' x ' + plateItem.plate_height
        }
      });
      this.$data.resultsLoaded = true;
    },
    csvExport() {
      if(this.$data.exportReportData.length === 0) {
        return
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(this.$data.exportReportData[0]).join(","),
        ...this.$data.exportReportData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      console.log(data.length);
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    }
  }
}
</script>

<style>
  .uppercase {
    text-transform: uppercase;
  }
</style>
